<template>
<div>
<h2>HOME</h2>
</div>
</template>

<script>
import ExternalLinks from "../components/ExternalLinks";

export default {
    components: {
        ExternalLinks,
    },
}
</script>
